// ST-1258 -Claude- Compact theme selector for system / light / dark.
import { useTranslation } from 'react-i18next';
import { useTheme } from './ThemeProvider';

export function ThemeToggle() {
  const { preference, setPreference } = useTheme();
  const { t } = useTranslation();

  const options = [
    { value: 'system' as const, icon: 'S', label: t('theme.system') },
    { value: 'light' as const, icon: 'L', label: t('theme.light') },
    { value: 'dark' as const, icon: 'D', label: t('theme.dark') },
  ];

  return (
    <div
      className="flex items-center rounded-full border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 p-0.5"
      role="group"
      aria-label="Theme"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => setPreference(option.value)}
          className={`h-7 w-7 rounded-full text-xs font-bold transition-colors ${
            preference === option.value
              ? 'bg-brand-600 text-white'
              : 'text-slate-500 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
          }`}
          aria-label={`Theme: ${option.label}`}
          title={`Theme: ${option.label}`}
        >
          {option.icon}
        </button>
      ))}
    </div>
  );
}
